// Card
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import CardTitle from './CardTitle';

const Wrapper = styled.div`
  background: rgba(255, 255, 255, .8);
  padding: 1vw;
  @media(min-width: 1060px) {
    padding: 0;
  }
  margin-bottom: 20px;

  .card-body {
    padding-left: 3vw;
    padding-right: 3vw;
    @media(min-width: 1060px) {
      padding-left: 2vw;
      padding-right: 2vw;
    }
  }
`;

function Card({ className = "", ...props }) {
  // default classes
  const classNames = [ "common-card uk-card uk-background-default-trans uk-box-shadow-medium", className ].join(" ");

  return (
    <Wrapper className={ classNames }>
      <CardTitle { ...props }/>
      <hr/>
      <div className="card-body uk-flex uk-flex-column uk-flex-center">
        { props.children }
      </div>
    </Wrapper>
  );
}
Card.propTypes = {
  children: PropTypes.node,
  cardTitle: PropTypes.string,
  className: PropTypes.string
};

export default Card;


// WEBPACK FOOTER //
// ./src/features/common/Card.js